<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Viga&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');

* {
    border: 0px black solid;
    background-color: #fff5f5;

}

.container_width {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 70px;

}


a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-right: 50px;
  padding-top: 40px;
  font-family: 'Poppins', sans-serif;;
  font-size: 15px;
  padding-left: 20px;
}

.title_story {
  font-size: 80px;
  font-family: 'Work Sans', sans-serif;
  padding-left: 20px;
  padding-top: 70px;
  color: #333042
}

.image_container {

  padding-top: 40px;
  padding-bottom: 40px;
}

.author {
  font-size: 20px;
  font-family: 'Poppins', sans-serif;;
  padding-left: 20px;


}
.small_icon {
  max-width: 20%;
  padding-top: 70px;

}


   @media (max-width: 575px){
        .small_icon {
          max-width: 50%;
          padding-top: 20px;

        }
        .title_story {
          font-size: 30px;
        }
        .author {
          font-size: 15px;
        }
      }

</style>

<template>
  <b-container fluid class="p-0">
    <MenuBar/>
    <b-row>
      <b-col md="8">
        <p class="title_story">Luo Shi Fen</p>
        <b-row>
          <b-col md="6">
            <p class="author">a visual recipe by biyibiyibiyi</p>

          </b-col>
        </b-row>
      </b-col>
      <b-col md="2" class="small_icon">
        <div class="zoom">
        <a href="/breakfast"><b-img center class="img-fluid" alt="Responsive image" src="media/avo_prev.png"> </b-img></a>
      </div>
      </b-col>
      <b-col md="2" class="small_icon">
        <div class="zoom">
        <a href="/recipe"><b-img center class="img-fluid" alt="Responsive image" src="media/recipe_next.png"> </b-img></a>
      </div>
      </b-col>

    </b-row>


    <b-row>
      <b-col md="5">
<div class='content'>
  <p>
    Luo Shi Fen is a soup based rice noodle set originally from Guangxi, China (Southwest bordering Vietnam). “Luo Shi” is a snail like creature that gives the soup base its flavor. Luo Shi Fen is like the durian fruit - some like it, and some hates it for the smell (its smelly and the odor will linger in the space where you cook and consume the dish).

  </p>
  <p>

  I tried to limit the consumption of this package, it is the most tasty brand I found in Asian supermarkets in NL. The too many small plastic packets made me reluctant to buy it on a regular basis - I only buy and eat it once in a while.


</p>
</div>

      </b-col>
      <b-col md="7">
        <b-container fluid>
          <div class="image_container">
          <b-row>
            <b-col md="6">
              <b-img class="img-fluid" src="media/noodles/1.JPG"> </b-img>
            </b-col>

            <b-col md="6">
              <b-img class="img-fluid" src="media/noodles/3.JPG"> </b-img>

            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <p></p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-img class="img-fluid" src="media/noodles/2.JPG"> </b-img>

            </b-col>
            <b-col md="6">
              <b-img class="img-fluid" src="media/noodles/4.JPG"> </b-img>

            </b-col>

          </b-row>
          <b-row>
            <b-col md="12">
              <p></p>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-img class="img-fluid" src="media/noodles/5.JPG"> </b-img>

            </b-col>
            <b-col md="6">
              <b-img class="img-fluid" src="media/noodles/6.JPG"> </b-img>

            </b-col>

          </b-row>

          <b-row>
            <b-col md="12">
              <p></p>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-img class="img-fluid" src="media/noodles/7.JPG"> </b-img>

            </b-col>
            <b-col md="6">
              <b-img class="img-fluid" src="media/noodles/8.JPG"> </b-img>
            </b-col>
          </b-row>

</div>

        </b-container>
      </b-col>
</b-row>
      </b-container>
</template>

<script>
import MenuBar from '../MenuBar'
export default {
    name: 'noodles',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
